import axios from 'axios';
import providerReviewTransformer from '../../transformers/providerReview';

export default (id) => {
  const promise = new Promise((resolve, reject) => {
    axios.get(process.env.VUE_APP_API_ADMIN_LOCATION + `reviews/${id}/reports`).then(
      ({ data }) => {
        let dataRes = {};

        if (data.data) {
          dataRes.data = providerReviewTransformer.fecthReport(data.data);
        }
        resolve(dataRes);
      },
      (error) => {
        reject(error);
      }
    );
  });

  return promise;
};
